import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {Modal, Button, Form, TextArea} from 'semantic-ui-react';
import {paths} from '../../../../../common/dictionaries/urls';
import {Actions} from '../../../../../common/actions';

const {updateUserRequest} = Actions;

const ObservationModal = ({
  code,
  push,
  formValues,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [observation, setObservation] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    if (formValues.status === 'R') {
      push(paths.UsersList);
    }
  }, [formValues]);

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  const handleTextChange = (e, {value}) => {
    setObservation(value);
  };

  const handleNotification = () => {
    const status = 'R';
    const updatedFormValues = {...formValues, status, observation};

    dispatch(updateUserRequest(code, updatedFormValues));
    closeModal();
  };

  return (
    <Modal
      onOpen={openModal}
      onClose={closeModal}
      open={modalIsOpen}
      size='tiny'
      className='observation-modal'
      trigger={
        <Button
          primary
          type='button'
          content='Rechazar'
          onClick={openModal}
        />}
    >
      <Modal.Header>Notificación de Rechazo</Modal.Header>
      <Modal.Content>
        <p>Observaciones</p>
        <Form>
          <TextArea
            placeholder='Observación de rechazo de solicitud'
            value={observation}
            onChange={handleTextChange}
          />
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={closeModal}>Cerrar</Button>
        <Button positive onClick={handleNotification}>
          Notificar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ObservationModal;
